/*
 * @Author: cc
 * @Date: 2020-04-05 16:34:53
 * @LastEditTime: 2020-05-05 13:38:31
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\myManuscript\myShare\myShareRouter.js
 * @Description: 
 */
'use strict';
angular.module('myShareRouterModule', ['myShareModule'])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('front.editctr.iWo.myShare', {
            url: '/myShare?&mediatype&siteid',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/iWo/myManuscript/myShare/myShare_tpl.html',
                    controller: 'myShareCtrl'
                }
            }
        });	
    }]);
